import React from "react";

const FormatSizeIcon = ({ color = "black" }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M3 12H6V19H9V12H12V9H3V12ZM9 7H14V19H17V7H22V4H9V7Z" fill="white" />
	</svg>
);

export default FormatSizeIcon;
